import React, { useState, useEffect, createContext, useContext } from 'react';
import { getCookie, deleteCookie, setCookie } from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = getCookie('token');
    const savedUser = localStorage.getItem('user');
    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
    } else {
      // Clear just in case they are out of sync
      deleteCookie('token');
      localStorage.removeItem('user');
    }
    setLoading(false);
  }, []);

  const login = (userData, token) => {
    setCookie('token', token, 1);
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    deleteCookie('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
